<template>
  <div class="wrapper position-relative">
    <div v-if="questions[currentQuestionIndex].isLast || currentPage === 'lastPage'">
      <top-three :lowestPrice="lowestPrice" :bestRating="bestRating" :bestAmazon="bestAmazon"
        :detailsContent="detailsContentLast" :explanations="finalExplanations" :shareable-link="shareableLink"
        @generate-share="generateShareLink" @copy-share="copyToClipboard" @reset="resetToStart"></top-three>

      <hr class="line-gap" />


      <h2>Weitere passende Monitore zu deiner Auswahl</h2>

      <div class="container-lg underQuestion col-md-8 pt-4">
        <div class="ml-2">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-black"> Sortierung </span>
          <select id="sortSelect" v-model="selectedSortOption" @change="sortProducts" name="sortSelect"
            class="spanSelectField form-select form-select-lg mb-1">
            <option value="Keine">Preis/Leistung</option>
            <option value="officeVal">Office: Bewertung</option>
            <option value="office_pl">Office: Preis/Leistung</option>
            <option value="pcGamingVal">Gaming: Bewertung</option>
            <option value="gaming_pl">Gaming: Preis/Leistung</option>
            <option value="mixedRating">Büro & Gaming: Bewertung</option>
            <option value="mixed_pl">Büro & Gaming: Preis/Leistung</option>
            <option value="editingVal">Editing: Bewertung</option>
            <option value="editing_pl">Editing: Preis/Leistung</option>
            <option value="preisSortAuf">Preis aufsteigend</option>
            <option value="preisSortAb">Preis absteigend</option>
          </select>
        </div>
        <div class="row g-0">
          <div :key="product.id" v-for="(product, index) in filteredProducts" class="col-lg-4 mb-4">
            <div class="card" :class="{ 'is-flipped': isFlipped(index) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel :product="product" />
                <div class="card-body">
                  <product-chart :product="product" />
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.paneltyp }} </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.horizontalPixel }}x{{ product.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="datasheet-button" @click="flipCard(index)">
                  <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price">{{ formatPreis(product.preisAmazonNeu) }}
                            €</span><br />
                        </div>
                        <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod :product="product" />
                  <button class="datasheet-button" @click="flipCard(index)"><i
                      class="fa-solid fa-rotate-left icon-margin-right"></i>Zurück zur Übersicht</button>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" v-if="products.length < this.totalProducts" @click="loadMoreProducts">
          Weitere Monitore laden
        </button>
      </div>
    </div>
    <div class="text-center" v-else-if="questions[currentQuestionIndex].currentQuestionIndex === 0">
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll" :key="currentQuestionIndex">
          <div class="row align-items center">
            <div class="col-md-6">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                    <div class="question-title mt-4">
                      <h2 class=" question-title text-center px-2 py-1">
                        {{ questions[currentQuestionIndex].question }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option, index in questions[currentQuestionIndex].options"
                      :key="'top-' + questions[currentQuestionIndex] + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="80" height="80" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="80" height="80" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <div style="margin-top: 60px;">
                      <SliderComponent @update-slider="setSliderValues" />
                    </div>
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center; margin-bottom: 20px;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/monitor-berater/dingoTest.png" alt="Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="firstPage-info mb-4 text-start">
        <div class="card2 mt-4">
          <!-- Header mit Flexbox -->
          <div class="header-container">
            <h1 class="firstPage">Die Monitor-Kaufberatung</h1>
            <img class="logoMw" src="/wp-content/plugins/monitor-berater/logo_small.png" width="160" height="80"
              alt="Monitorwelt Logo">
          </div>

          <!-- Einleitungstexte -->
          <div class="intro-text">
            <p>
              <strong>Wähle jetzt deinen primären Anwendungsbereich</strong> – auf dieser Basis stellen wir dir gezielte
              Folgefragen, um deine individuellen Bedürfnisse zu verstehen.
              Im Hintergrund gleichen wir deine Angaben mit tausenden Monitor-Modellen ab – so findest du schnell und
              unkompliziert den idealen Monitor für dich.
            </p>

            <p>
              Egal ob fürs Homeoffice, Gaming, hybrides Arbeiten oder spezialisierte Anwendungen: Unsere
              <strong>intelligente Monitor-Kaufberatung</strong> analysiert deine Anforderungen und liefert konkrete
              Empfehlungen – personalisiert statt generisch.
            </p>

            <p>
              Am Ende bekommst du drei Vorschläge: den <strong>Günstigsten</strong>, den <strong>Leistungsstärksten für
                deinen Einsatzbereich</strong> und den <strong>Preis-/Leistungssieger</strong>.
              Zusätzlich erhältst du weitere passende Modelle – exakt abgestimmt auf dein persönliches Nutzungsszenario.
            </p>

            <p>
              Beispiel: Du arbeitest viel im Homeoffice oder Büro und suchst einen zuverlässigen Monitor – möchtest aber
              abends
              auch mal in ein atmosphärisches Storygame eintauchen? Vielleicht schwankst du zwischen 27 und 34 Zoll, und
              dein Raum ist nur mittelmäßig beleuchtet. Solche Überlegungen sind nur ein Beispiel von vielen, die unser
              Kaufberater berücksichtigt. Statt allgemeiner Empfehlungen bekommst du Vorschläge, die genau zu deinem
              Profil passen – individuell und mit Blick auf die bestmöglichen Preis-Leistungs-Verhältnis. Keine Lust,
              dich durch technische Daten zu wühlen? Voilà – hier sind deine drei Kennzahlen-Modelle!
            </p>
          </div>
        </div>
        <top-three-example v-if="lowestPrice && bestRating && bestAmazon" :lowestPrice="lowestPrice"
          :bestRating="bestRating" :bestAmazon="bestAmazon" />
        <div class="card2 mt-4">
          <div class="header-container">
            <h1 class="firstPage">Erkennen deiner Anforderung und Nutzung</h1>
          </div>
          <div class="intro-text">
            <p>
              Ob fürs Gaming, Homeoffice, für Grafikbearbeitung, deine Konsole oder eine Kombination aus allem – jedes
              Nutzerprofil
              stellt ganz eigene Anforderungen an die verbaute Technik und setzt andere Prioritäten. Genau hier setzt
              unsere Kaufberatungung an: Die interaktive Sprechblase unterstützt dich dabei, die
              passende Auswahl zu treffen – einfach, gezielt und individuell.

              Denn „Gaming“ ist nicht gleich Gaming: Geht es dir um visuell beeindruckende Storygames, schnelle
              Reaktionszeiten für kompetitive Titel oder sogar um Ambitionen im E-Sports-Bereich? Unser System erkennt
              solche Unterschiede und gewichtet technische Merkmale entsprechend – mit Blick auf Details, Anwendung und
              das Preis-Leistungs-Verhältnis. So gibt es in jedem Anwendungsbereich eine Vielzahl an
              Verwendungsprofilen.
            </p>
          </div>
        </div>

        <MindMap></MindMap>
        <div class="card2 mt-4">
          <div class="intro-text">
            <p>
              Diese Nutzerprofile geben einen grundlegenden Einblick, um typische Anwendungsfälle und
              deren spezifische Bedürfnisse zu repräsentieren. Doch natürlich bleiben diese Profile nur an der
              Oberfläche und sind nicht vollends personalisiert. Was ist mit einer Wandhalterung? Welche Größe
              präferierst du wirklich?
              Oder benötigst du explizit eine Kamera am Bildschirm?

              Genau an diesem Punkt setzt unser Monitor-Kaufberater an: Dieser deckt nicht nur gängige
              Standardprofile ab, sondern berücksichtigt darüber hinaus detaillierte, individuelle Wünsche und
              komplexere Szenarien und dein Anforderungsprofil. Dank fortschrittlicher Technologie und präziser
              Fragestellungen erkennt der
              Kaufberater schnell, auf welche spezifischen Details es für dich ankommt. Egal ob Gaming-Enthusiast, Profi
              im Homeoffice, Grafikdesigner oder Entwickler – die intelligente Kaufberatung unterstützt
              dich gezielt bei der optimalen Auswahl eines Monitors, der perfekt zu deinen persönlichen Anforderungen
              und Präferenzen passt.
            </p>
          </div>
        </div>
        <div class="details-wrapper">
          <details v-for="(content, index) in detailsContent" :key="index">
            <summary class="no_select" @click="handleSummaryClick(index)">
              {{ content.summary }}
            </summary>
            <div class="detail-desc no_select">
              {{ content.description }}
            </div>
          </details>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll">
          <div class="row align-items center">
            <div v-if="showProgress" class="col-12">
              <div class="progress-glass" :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100"
                role="progressbar">
                <span class="progress-glass__fill" :style="{ width: progressPercentage + '%' }">
                  <span class="sr-only">{{ progressPercentage }} %</span>
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <transition appear name="slide-fade" mode="out-in">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions.length > 0">
                    <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                      <div class="question-title mt-4">
                        <h2 class="question-title text-center px-2 py-1">
                          {{ questions[currentQuestionIndex].question }}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div v-if="isLoader" class="overlay">
                    <div class="spinner-container">
                      <img src="/wp-content/plugins/monitor-berater/logo_small.png" alt="Loading Icon"
                        class="rotating-image" />
                      <p class="loading-text">{{ loadingMessages[currentMessageIndex] }}</p>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">

                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option, index in questions[currentQuestionIndex].options"
                      :key="currentQuestionIndex + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="80" height="80" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-if="extraTextIndices.includes(currentQuestionIndex)" class="text-muted">
                    Alle dargestellten Marken, Designs und Logos sind Eigentum der jeweiligen Unternehmen.
                  </div>

                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="80" height="80" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <SliderComponent @update-slider="setSliderValues" />
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13-back" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
              </transition>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox typewriter">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/monitor-berater/dingoTest.png" alt="Hund Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="questions[currentQuestionIndex].isLast"></div>
      <div v-else class="container-lg underQuestion col-md-8 pt-4">
        <div class="row">
          <div :key="product.id" v-for="(product, index) in filteredProducts" class="col-lg-4 mb-4">
            <div class="card" :class="{ 'is-flipped': isFlipped(index) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel :product="product" />
                <div class="card-body">
                  <product-chart :product="product" />
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Panel</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.paneltyp }} </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.horizontalPixel }}x{{ product.vertikalPixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.frequenz }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="datasheet-button" @click="flipCard(index)"><i
                    class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price">{{ formatPreis(product.preisAmazonNeu) }}
                            €</span><br />
                        </div>
                        <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod :product="product" />
                  <button class="datasheet-button" @click="flipCard(index)">Zurück zur Übersicht</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" @click="loadMoreProducts">
          Weitere Monitore laden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import SliderComponent from "/src/components/SliderComponent.vue";
import SliderSteps from "/src/components/SliderSteps.vue";
import ProductChart from "/src/components/ProductChart.vue";
import PicCarousel from "/src/components/PicCarousel.vue";
import DatenblattMod from "./components/DatenblattMod.vue";
import TopThreeDatenblattMod from "./components/TopThreeDatenblattMod";
import TopThree from "./components/TopThree.vue";
import TypeWriter from "./components/TypeWriter.vue";
import Feedback from "/src/components/Feedback.vue";
import TypeWriterEffect from "/src/components/TypeWriterEffect.vue";
import TopThreeExample from "./components/TopThreeExample.vue";
import MindMap from "./components/MindMap.vue";
import $ from "jquery";


export default {
  components: {
    SliderComponent,
    SliderSteps,
    ProductChart,
    PicCarousel,
    DatenblattMod,
    TopThree,
    TopThreeExample,
    MindMap,
    TypeWriter,
    TypeWriterEffect,
    TopThreeDatenblattMod,
    Feedback,
  },

  created() {
    this.updateDescription();
    const urlParams = new URLSearchParams(window.location.search);
    const sharedResults = urlParams.get('r');

    if (sharedResults) {
      try {

        let base64String = sharedResults
          .replace(/-/g, '+')
          .replace(/_/g, '/');


        while (base64String.length % 4) {
          base64String += '=';
        }

        const jsonString = atob(base64String);
        const parsedData = JSON.parse(jsonString);

        if (parsedData && Array.isArray(parsedData.aq) && Array.isArray(parsedData.so)) {
          this.answeredQuestions = parsedData.aq;
          this.selectedOptions = parsedData.so;

          this.fetchResults();
          this.collectExplanations();
        } else {

          console.error("Ungültige Datenstruktur im geteilten Link.");
          this.resetToStart();
        }
      } catch (e) {
        console.error("Fehler beim Verarbeiten des geteilten Links:", e);
        this.resetToStart();
      }
    } else {
      this.currentPage = 'start';
    }
  },


  methods: {
    //Progress Functions start
    getNextIndexAlongPath(questionIndex) {
      const q = this.questions[questionIndex];
      if (!q || q.isLast) return null;
      const answeredPos = this.answeredQuestions.indexOf(q.id);
      if (answeredPos !== -1) {
        const selectedValue = this.selectedOptions[answeredPos];
        const opt = q.options.find(o => o.id === selectedValue);
        return this.questions.findIndex(x => x.id === opt?.nextQuestionId);
      }

      return this.questions.findIndex(
        x => x.id === q.options[0].nextQuestionId
      );
    },

    countPathLength(questionIndex) {
      let count = 0;
      let idx = questionIndex;
      while (idx !== null && idx !== -1) {
        count++;
        const next = this.getNextIndexAlongPath(idx);
        idx = next;
      }
      return count;
    },

    updateProgress() {
      if (this.currentPage === 'lastPage') {
        this.progressPercentage = 100;
        return;
      }
      const answered = this.answeredQuestions.length;         // schon fix
      const remaining = this.countPathLength(this.currentQuestionIndex);
      const total = answered + remaining;

      this.progressPercentage = Math.round((answered / total) * 100);
    },
    //Progress Functions end

    updateUrlWithResults() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      const newUrl = `${window.location.pathname}?r=${urlSafeBase64}`;

      window.history.pushState({ page: 'results' }, 'Ergebnisse', newUrl);
    },

    resetToStart() {
      this.currentPage = 'start';
      this.flippedCards = [];
      this.currentQuestionIndex = 0;
      this.nextQuestionIndex = null;
      this.answeredQuestions = [];
      this.selectedOptions = [];
      this.products = [];
      this.loadedProducts = [];
      this.productsPerLoad = 9;
      this.loadedProductIndex = 9;
      this.isLoader = false;
      this.feedback = '';
      this.message = '';
      this.selectedSortOption = "Keine";
      this.finalExplanations = [];
      this.shareableLink = null;


      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      this.updateDescription();
      this.scrollToTop();
    },


    fetchResults() {
      if (this.answeredQuestions.length === 0) {
        console.error("Keine Antworten zum Abrufen der Ergebnisse vorhanden.");
        return;
      }

      this.currentPage = 'loading';

      $.ajax({
        url: "/wp-content/plugins/monitor-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.loadedProductIndex,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
          this.currentPage = 'lastPage';

          this.updateUrlWithResults();
          // --- NEUER TEIL ENDE ---
        },
        error: (error) => {
          console.error("Fehler beim Abrufen der Daten:", error);
          this.currentPage = 'start';
        },
      });
    },
    
    generateShareLink() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');

      const baseUrl = window.location.origin + window.location.pathname;
      this.shareableLink = `${baseUrl}?r=${urlSafeBase64}`;
    },

    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    sortProducts() {
      $.ajax({
        url: "/wp-content/plugins/monitor-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.loadedProductIndex,
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
          console.error("Fehler beim Sortieren der Produkte", error);
        },
      });
    },


    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    sendFeedback() {
      $.ajax({
        url: '/wp-content/plugins/monitor-berater/get_feedback.php',
        method: 'POST',
        data: {
          feedback: this.feedback
        },
        dataType: 'json',
        success: (response) => {
          this.message = response.message;
          if (response.status === 'success') {
            this.feedback = '';
          }
        },
        error: (xhr, status, error) => {
          this.message = 'Es gab einen Fehler beim Senden des Feedbacks.';
        }
      });
    },

    updateDescription() {
      this.currentDescription = this.questions[this.currentQuestionIndex].tooltip;
      this.$nextTick(this.resetTypewriter);
    },
    flipCard(index) {
      const cardIndex = this.flippedCards.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards.push(index);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },
    isFlipped(index) {
      return this.flippedCards.includes(index);
    },

    resetTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      paragraphs.forEach(paragraph => paragraph.setAttribute("data-content", ""));
      this.startTypewriter();
    },
    startTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      let currentLetter = 0;
      let currentParagraph = 0;
      const typeWriter = () => {
        if (currentParagraph >= paragraphs.length) return;
        const text = paragraphs[currentParagraph].textContent;

        if (currentLetter < text.length) {
          paragraphs[currentParagraph].setAttribute("data-content", text.slice(0, currentLetter + 1));
          currentLetter++;
        } else {
          currentParagraph++;
          currentLetter = 0;
        }

        setTimeout(typeWriter, currentLetter === text.length ? 500 : 25);
      };

      typeWriter();
    },
    loadMoreProducts() {
      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      this.loadedProductIndex += 9;
      $.ajax({
        url: "/wp-content/plugins/monitor-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.loadedProductIndex,
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    getWhiteBorder(img, pixelCount) {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imgData.data;
      const borders = {};

      function isWhiteLine(startIndex, endIndex, stride) {
        for (let i = startIndex; i <= endIndex; i += stride) {
          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];
          const a = pixels[i + 3];
          if (!(r > 253 && g > 253 && b > 253 && a > 253)) {
            return false;
          }
        }
        return true;
      }
      if (
        isWhiteLine(
          pixelCount * canvas.width * 4,
          ((pixelCount + 1) * canvas.width - 1) * 4,
          4
        )
      ) {
        borders.top = true;
      }
      if (
        isWhiteLine(
          (canvas.height - pixelCount) * canvas.width * 4,
          (canvas.height - pixelCount + 1) * canvas.width * 4 - 1,
          4
        )
      ) {
        borders.bottom = true;
      }
      if (
        isWhiteLine(
          pixelCount * 4,
          (canvas.height - 1) * canvas.width * 4 + pixelCount * 4,
          canvas.width * 4
        )
      ) {
        borders.left = true;
      }
      if (
        isWhiteLine(
          (canvas.width - pixelCount) * 4,
          canvas.height * canvas.width * 4 +
          (canvas.width - pixelCount) * 4 -
          1,
          canvas.width * 4
        )
      ) {
        borders.right = true;
      }

      return borders;
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInRight animate__${delay}ms`;
    },

    initSlider() {
      if (!this.isSliderInitialized) {
        const sliderElement = this.$refs.slider77;
        noUiSlider.create(sliderElement, {
          start: [0],
          range: {
            min: 0,
            max: 100,
          },
        });
        this.isSliderInitialized = true;
      }
    },

    collectExplanations() {
      let explanations = [];

      this.answeredQuestions.forEach((questionId, index) => {
        const questionObj = this.questions.find(q => q.id === questionId);
        const selectedOptionId = this.selectedOptions[index];

        if (questionObj && !Array.isArray(selectedOptionId)) {
          // Radio
          const selectedOption = questionObj.options.find(opt => opt.id === selectedOptionId);
          if (selectedOption && selectedOption.explanation) {
            explanations.push(selectedOption.explanation);
          }
        } else if (questionObj && Array.isArray(selectedOptionId)) {
          // Checkbox(en) oder Slider
          selectedOptionId.forEach(optId => {
            const selectedOpt = questionObj.options.find(opt => opt.id === optId);
            if (selectedOpt && selectedOpt.explanation) {
              explanations.push(selectedOpt.explanation);
            }
          });
        }
      });

      // Jetzt das gesammelte Array in eine reaktive Variable schreiben
      this.finalExplanations = explanations;
    },

    nextQuestionWithDelay() {
      if (this.questions[this.currentQuestionIndex].needLoader) {
        this.isLoader = true;
        this.updateUrlWithResults();
        this.collectExplanations();
        this.startMessageRotation();
        setTimeout(() => {
          this.isLoader = false;
          clearInterval(this.messageInterval);
          this.currentMessageIndex = 0;
          this.nextQuestion();
          this.scrollToTop();

        }, 5000);
      }
      else {
        setTimeout(() => {

          this.nextQuestion();
          this.scrollToTop();

        }, 150);
      }
    },
    setSliderValues(lowerValue, upperValue) {
      this.questions[this.currentQuestionIndex].lowerValue = lowerValue;
      this.questions[this.currentQuestionIndex].upperValue = upperValue;
    },

    setSliderValue(value) {
      this.questions[this.currentQuestionIndex].selectedOptionId = value;
    },

    nextQuestion() {
      this.loadedProductIndex = 9;
      let nextQuestionIndex = 0;
      let nextQuestionId = 0;
      if (this.currentQuestionIndex <= this.questions.length - 1) {

        if (this.questions[this.currentQuestionIndex].isSlider) {
          this.selectedOptions.push([
            Number(this.questions[this.currentQuestionIndex].lowerValue),
            Number(this.questions[this.currentQuestionIndex].upperValue)
          ]);
          nextQuestionIndex = 18;
          nextQuestionId = 18;
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }


        else if (this.questions[this.currentQuestionIndex].isStepSlider) {
          const sliderValue = this.questions[this.currentQuestionIndex].selectedOptionId
          this.selectedOptions.push(Number(sliderValue));
          nextQuestionId = this.questions[this.currentQuestionIndex].options[0].nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }

        else if (this.questions[this.currentQuestionIndex].isCheckbox) {
          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionIds
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);

          if (this.currentQuestionIndex === 14) {
            nextQuestionIndex = 15;
          } else if (this.currentQuestionIndex === 13) {
            nextQuestionIndex = 3;
          }

        }
        else if (!(this.questions[this.currentQuestionIndex].isCheckbox)) {
          const selectedOption = this.questions[
            this.currentQuestionIndex
          ].options.find(
            (option) =>
              option.id ===
              this.questions[this.currentQuestionIndex].selectedOptionId
          );
          nextQuestionId = selectedOption.nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionId
          );

        }

        this.currentQuestionIndex = nextQuestionIndex;
        this.nextQuestionIndex = null;
        this.updateDescription();
      } else {

      }


      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      $.ajax({
        url: "/wp-content/plugins/monitor-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.loadedProductIndex,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
      this.updateProgress();
      this.scrollToTop();

    },

    getExampleData() {
      const answeredQuestionsExample = [0, 21, 27, 9, 10, 17, 13, 14, 15]
      const selectedOptionsExample = [4, 1, 3, 4, [26, 34], 1, [2], 1, 1]
      const demoLimit = 15

      $.ajax({
        url: '/wp-content/plugins/monitor-berater/apiNewData.php',
        method: 'GET',
        data: {
          answeredQuestions: answeredQuestionsExample,
          selectedOptions: selectedOptionsExample,
          limit: demoLimit
        },
        dataType: 'json',
        success: response => {
          this.lowestPrice = response.lowPriceProduct
          this.bestRating = response.bestGamingProduct
          this.bestAmazon = response.bestAmazonProduct
        },
        error: err => {
          console.error('Demo-Daten konnten nicht geladen werden:', err)
        }
      })
    },

    goBack() {
      this.loadedProductIndex = 9;
      if (this.answeredQuestions.length === 1) {
        const previousQuestionIndex = this.answeredQuestions.pop();
        const previousQuestionId = this.questions[previousQuestionIndex].id;
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );
        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.nextQuestionIndex = null;
          this.questions[previousQuestionIndex].selectedOptionId =
            this.selectedOptions.pop();
        }
      }

      else {
        const previousQuestionId = this.answeredQuestions.pop();
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );

        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.questions[previousQuestionIndexInArray].selectedOptionId =
            this.selectedOptions.pop();
        }
      }
      this.updateDescription();
      this.updateProgress();

      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;

      $.ajax({
        url: "/wp-content/plugins/monitor-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.loadedProductIndex,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    isNextButtonDisabled() {

      const selectedOptionId =
        this.questions[this.currentQuestionIndex].selectedOptionId;
      const lowerValue = this.questions[this.currentQuestionIndex].lowerValue;
      const upperValue = this.questions[this.currentQuestionIndex].upperValue;
      const isLowerValue = true;
      const isHigherValue = true;
      const isSlider = this.questions[this.currentQuestionIndex].isSlider;
      const isStepSlider = this.questions[this.currentQuestionIndex].isStepSlider;
      const isCheckbox = this.questions[this.currentQuestionIndex].isCheckbox;

      if (isSlider || isCheckbox || isStepSlider || isLowerValue || isHigherValue) {

        return false;
      } else {
        return !selectedOptionId;
      }
    },

    startMessageRotation() {
      this.messageInterval = setInterval(() => {
        this.currentMessageIndex =
          (this.currentMessageIndex + 1) % this.loadingMessages.length;
      }, 2500);
    }
  },

  mounted() {
    if (this.currentPage === 'start') {

      this.getExampleData()
    }

    const paragraphs = document.querySelectorAll(".typewriter > *");
    if (paragraphs.length === 0) {
      return;
    }

    let currentLetter = 0;
    let currentParagraph = 0;

    const typeWriter = () => {
      if (
        currentLetter <
        paragraphs[currentParagraph].textContent.length
      ) {
        paragraphs[currentParagraph].setAttribute(
          "data-content",
          paragraphs[currentParagraph].textContent.slice(
            0,
            currentLetter + 1
          )
        );
        currentLetter++;
      } else {
        currentParagraph++;
        currentLetter = 0;
      }

      if (currentParagraph === paragraphs.length) return;

      if (
        currentLetter ===
        paragraphs[currentParagraph].textContent.length
      )
        setTimeout(typeWriter, 500);
      else setTimeout(typeWriter, 25);
    };

    typeWriter();
    this.$nextTick(() => {
      const imgs = this.$el.querySelectorAll(".card-img-top");

      imgs.forEach((img) => {
        img.addEventListener("load", () => {
          const longerSide = Math.max(img.naturalWidth, img.naturalHeight);
          const pixelCount = Math.round(longerSide * 0.1);

          const borders = this.getWhiteBorder(img, pixelCount);
          const keys = Object.keys(borders);

          if (keys.length > 0) {
            if (keys.length === 4) {
              img.style.transform = "scale(1.10)";
            } else {
              let translateX = 0;
              let translateY = 0;
              if (borders.top && borders.bottom) {
              } else if (borders.top) {
                translateY = -4;
              } else if (borders.bottom) {
                translateY = 4;
              }
              if (borders.left && borders.right) {

              } else if (borders.left) {
                translateX = -4;
              } else if (borders.right) {
                translateX = 4;
              }

              img.style.transform = `translate(${translateX}%, ${translateY}%)`;
            }
          } else {
            img.style.transform = "scale(0.92)";
          }
        });

        if (img.complete) {
          img.dispatchEvent(new Event("load"));
        }
      });
    });



  },

  computed: {
    filteredProducts() {
      return this.products.slice(0, this.loadedProductIndex);
    },
  },

  data() {
    return {
      extraTextIndices: [6, 26, 28, 30],
      currentPage: 'start',
      flippedCards: [],
      currentQuestionIndex: 0,
      nextQuestionIndex: null,
      answeredQuestions: [],
      selectedOptions: [],
      products: [],
      totalProducts: 0,
      lowestPrice: null,
      bestRating: null,
      bestAmazon: null,
      loadedProducts: [],
      productsPerLoad: 9,
      loadedProductIndex: 9,
      isLoader: false,
      feedback: '',
      message: '',
      selectedSortOption: "Keine",
      finalExplanations: [],
      shareableLink: null,
      showProgress: true,

      loadingMessages: [
        "Daten werden analysiert!",
        "Empfehlungen generieren..",
      ],
      currentMessageIndex: 0,
      messageInterval: null,
      detailsContentLast: [
        {
          summary: "Wieso diese zu dir passen?",
          description:
            "Geschafft! Durchstöbere deine Top-3 Monitor-Empfehlungen für deine geplante Nutzung: Der preisgünstigste Monitor, der stärkste in deinem Anforderungsbereich und der Preis-/Leistungssieger gemäß unserem Algorithmus. Weiter unten findest du weitere Empfehlungen, die deine persönlichen Anforderungen erfüllen oder übertreffen und nach unseren berechneten Preis-/Leistungswerten sortiert sind.",
        },
        {
          summary: 'Wieso wir teilweise auch "Gaming-Monitore" für Office-Verwendungen empfehlen?',
          description:
            "Gaming-Monitore sind vielseitig und leistungsstark und daher nicht nur für Gamer interessant. Dank ihrer Spezifikationen eignen sie sich oftmals auch für Office-Aufgaben und ermöglichen ein angenehmes Arbeiten. Wichtig zu wissen: Während Gaming-Monitore problemlos als Office-Monitore genutzt werden können, erfüllen klassische Office-Monitore nicht die Anforderungen, die für ein optimales Gaming-Erlebnis nötig sind.",
        },

      ],
      detailsContent: [
        {
          summary: "Warum ist der Monitor-Berater unabhängig?",
          description:
            "Unsere Monitor-Kaufberatung ist unabhängig, da sie ausschließlich auf technische Spezifikationen und Bewertungen basiert und nicht an bestimmte Marken oder Hersteller gebunden ist. Anders als ein Online-Shop, bei dem oft bestimmte Produkte bevorzugt beworben werden, konzentrieren wir uns darauf, dir die besten Monitore zu empfehlen, die genau zu deinen individuellen Anforderungen passen. Wir sind ein Affiliate-Dienst und kein Händler. Das bedeutet, wir verkaufen keine Monitore direkt, sondern verweisen lediglich auf externe Anbieter, bei denen die empfohlenen Produkte verfügbar sind. Diese Unabhängigkeit ermöglicht es uns eine objektive, individuelle und neutrale Beratung anzubieten. Unser Ziel ist es den Monitor zu finden, der perfekt auf deine Anforderungen zugeschnitten ist – unabhängig von der Marke, Hersteller oder Preis.",
        },
        {
          summary: "Wie funktioniert die Monitor-Kaufberatung?",
          description:
            "Der Berater führt dich durch durchschnittlich 7 Fragen, um deine Aufgaben und Anforderungen zu ermitteln. Die Anzahl der Fragen variiert, da ein individueller Pfad der Fragen in Abhängigkeit deiner Antworten generiert wird. Gleichzeitig gibt unser intelligenter Dingo dir Hilfestellung, um die passende Antwort auswählen zu können. Wichtig ist, dass die Auswahl wahrheitsgemäß ist, da wir gegebenenfalls nicht den leistungsstärksten Monitor innerhalb eines Anwendungsbereiches empfehlen möchten, sondern den passendsten Monitor für deine persönlichen Bedürfnisse.",
        },
        {
          summary: "Wieso wir keine Daten von dir speichern?",
          description:
            "Deine Daten werden von diesem Tool weder gespeichert noch weiterverarbeitet. Alle von dir eingegebenen Antworten bleiben nur während der Nutzung auf deinem Gerät und werden beim Schließen des Monitor-Beraters vollständig gelöscht.",
        },
        {
          summary: "Wieso du keinerlei Aufpreis zahlst?",
          description:
            "Unser Service ist für dich komplett kostenlos, weil wir ausschließlich als Affiliate agieren. Das bedeutet, dass wir keine Monitore direkt verkaufen, sondern auf externe Anbieter und Partner verlinken, bei denen die empfohlenen Produkte erhältlich sind. Wenn du über einen unserer Links einen Kauf tätigst, erhalten wir möglicherweise eine geringfügige Provision, ohne dass dir zusätzliche Kosten entstehen. Diese Provision ermöglicht es uns, dir weiterhin eine umfassende, unabhängige und neutrale Kaufberatung anzubieten, ohne dass du dafür bezahlen musst.",
        },
      ],

      openIndex: 0,

      questions: [
        {
          currentQuestionIndex: 0,
          id: 0,
          question: "Was hast du mit deinem neuen Monitor vor?",
          tooltip: "Unsere smarte, interaktive Kaufberatung findet mit dir gemeinsam den Monitor, der ideal zu deinen Bedürfnissen passt – ganz ohne technische Komplexität, aber mit echtem Expertenwissen. Wähle dazu einfach deinen Anwendungsbereich aus, damit wir die folgenden Fragen und Optionen optimal auf dich abstimmen können.",
          options: [
            {
              id: 2,
              label: "Büro-/Grafikanwendung",
              para: "work",
              nextQuestionId: 1,
              iconPath: "/wp-content/plugins/monitor-berater/Textverarbeitung.png",
            },
            {
              id: 3,
              label: "Gaming",
              para: "gaming",
              nextQuestionId: 5,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming.png",
            },
            { id: 4, label: "Beides: Büro & Gaming", para: "mix", nextQuestionId: 21, iconPath: "/wp-content/plugins/monitor-berater/mainMonitor.png", explanation: "Ein Allrounder kombiniert gute Bildqualität und Ergonomie für Büroanwendungen mit schnellen Reaktionszeiten fürs Gaming.", },
            { id: 5, label: "Konsolen-Gaming", para: "konsole", nextQuestionId: 60, iconPath: "/wp-content/plugins/monitor-berater/gamingConsole.png", explanation: "Diese Konsolenmonitore unterstützen hohe Auflösungen und flüssige Darstellung.", }
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 1,
          id: 1,
          question: "Lass uns genauer werden: Was ist dein Haupt-Anwendungsbereich fürs Office?",
          tooltip: 'Büroarbeit beinhaltet allgemeine Aufgaben wie die Nutzung von Word, Excel oder ähnlicher Software und ist in den anderen Auswahlmöglichkeiten bereits enthalten. Das bedeutet: Wenn du hauptsächlich Büroanwendungen nutzt, aber beispielsweise ab und zu programmierst, wähle "Programmieren/ Softwareentwicklung" als deinen Anwendungsbereich.',
          options: [
            {
              id: 1,
              label: "Büroarbeit und Textverarbeitung",
              nextQuestionId: 18,
              iconPath: "/wp-content/plugins/monitor-berater/Textverarbeitung.png",
              explanation: "Für deine Büroanwendungen empfiehlt sich ein Monitor mit augenschonender Darstellung und guter Ergonomie.",
            },
            {
              id: 2,
              label: "Programmieren/ Softwareentwicklung",
              nextQuestionId: 18,
              iconPath: "/wp-content/plugins/monitor-berater/Programmieren.png",
              explanation: "Beim Programmieren sind scharfe Darstellung und gute Ergonomie wichtig, oft auch ein größeres Display oder Multi-Setup.",
            },
            {
              id: 3,
              label: "Grafikdesign/ Bild- und Videobearbeitung",
              nextQuestionId: 8,
              iconPath: "/wp-content/plugins/monitor-berater/GrafikundVideo.png",
              explanation: "Bild- und Videobearbeitung erfordern Monitore mit guter Farbwiedergabe und hoher Auflösung.",
            },
            {
              id: 4,
              label: "CAD-Design und 3D-Modellierung",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/monitor-berater/CADund3D.png",
              explanation: "CAD und 3D profitieren besonders von hoher Auflösung und präziser Darstellung feiner Details.",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 2,
          id: 2,
          question:
            'Hast du vor, ein Multi-Setup zu verwenden, also mehr als nur einen Monitor?',
          tooltip: '*Achtung: "Ja, aber mit extrem dünnem Rahmen." schränkt die Auswahl sehr stark ein!',
          options: [
            { id: 1, label: "Ja und die Rahmendicke ist nicht entscheidend.", nextQuestionId: 3, iconPath: "/wp-content/plugins/monitor-berater/MehrfachmonitorJa.png" },
            { id: 2, label: "Nein", nextQuestionId: 7, iconPath: "/wp-content/plugins/monitor-berater/MonitorFinderSymbole.png" },
            { id: 3, label: "Ja, aber mit extrem dünnem Rahmen.*", nextQuestionId: 3, iconPath: "/wp-content/plugins/monitor-berater/Mehrfachmonitor.png" },
            {
              id: 4,
              label: "Noch nicht, aber später denkbar.",
              nextQuestionId: 7,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 3,
          id: 3,
          tooltip: "Überlege, ob der Monitor in der Nähe von Fenstern steht, durch die direktes Sonnenlicht auf den Bildschirm fällt. Solche Lichtquellen können das Ablesen am Display beeinträchtigen, dem durch technische Spezifikationen entgegen gewirkt werden kann. Bei rein künstlicher Beleuchtung, wie Lampen, können diese sanfter berücksichtigt werden.",
          question: "Wie sind die Lichtverhältnisse an dem Platz, wo dein neuer Monitor stehen wird?",
          options: [
            {
              id: 1,
              label:
                "Direkte Sonneneinstrahlung auf das Display ist durchgehend vorhanden.",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Sonnenlicht.png",

            },
            {
              id: 2,
              label:
                "Überwiegend künstliches Licht bzw. nutze meist Jalousinen oder ähnliches.",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/KünstlichesLicht.png",

            },
            {
              id: 3,
              label: "Der Monitor steht überwiegend in dunkler Umgebung.",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Dunkel.png",
            },
            {
              id: 4,
              label: "Kann ich nicht genau sagen.",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 4,
          id: 4,
          question: "Möchtest du explizit einen Monitor auf eSports-Niveau?",
          tooltip: 'Ein Monitor auf eSports-Niveau muss Leistungsmerkmale bieten, die im wettbewerbsorientierten Gaming entscheidend sind: Eine extrem niedrige Reaktionszeit und hohe Bildwiederholfrequenz sorgen dafür, dass Frames ohne Verzögerung angezeigt werden. Wähle bitte nur "Ja", wenn du dahingehend keine Abstriche machenn möchtest.',
          options: [
            { id: 1, label: "Ja", nextQuestionId: 6, iconPath: "/wp-content/plugins/monitor-berater/gegenNeu.png", explanation: "Deine eSports-Monitore zeichnen sich durch extrem niedrige Reaktionszeiten und besonders hohe Bildwiederholraten aus." },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
            {
              id: 3,
              label: "Kann, aber muss nicht.",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 5,
          id: 5,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Monitors hängt davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und PvP-Gaming",
              nextQuestionId: 4,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_PvP.png",
              explanation: "Wettbewerbsorientiertes Gaming erfordert Monitore mit maximaler Reaktionsgeschwindigkeit und hoher Bildrate."
            },
            {
              id: 2,
              label:
                "Bevorzugt wettbewerbsorientiertes Gaming mit der Option auf angemessene Immersion",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_KompetitivUeberImmersion.png",
              explanation: "Eine gute Balance aus schnellen Reaktionszeiten und hochwertiger Bildqualität sorgt für Flexibilität in Spielen."
            },
            {
              id: 3,
              label: "Bevorzugt Immersion mit gelegentlichem wettbewerbsorientierten Gaming",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_ImmersionUeberKompetitiv.png",
              explanation: "Für intensive Immersion ist ein Monitor mit guter Farbdarstellung und angemessener Reaktionszeit optimal."
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 30,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_Immersion.png",
              explanation: "Für ein intensives Spielerlebnis sind hohe Auflösung, exzellente Farben und starke Kontraste ausschlaggebend."
            },
            /*
            {
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 6,
          id: 6,
          question: "Ist dir bekannt von welchem Hersteller deine Grafikkarte ist?",
          tooltip: "Der Hersteller der Grafikkarte ist nicht unbedeutend, da dadurch zusätzliche Funktionen des Monitors berücksichtigt werden können.",
          options: [
            {
              id: 1,
              label: "NVIDIA",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/nvidia_logo.png",
              explanation: "Mit deiner Nvidia-Grafikkarte wurden extra GSYNC-Monitore berücksichtigt!"
            },
            {
              id: 2,
              label: "AMD",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/amd_logo.png",
              explanation: "Mit deiner AMD-Grafikkarte wurden extra FreeSync-Monitore berücksichtigt!"
            },
            {
              id: 3,
              label: "Intel",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/intel_logo.png",
            },
            {
              id: 4,
              label: "Unsicher",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 7,
          id: 7,
          question: "Benötigst du zwingend eine intergrierte Kamera direkt im Monitor?",
          tooltip: 'Bedenke, dass Kameras auch als Peripheriegerät nachgekauft werden können, dennoch kann sich eine integrierte Kamera im Office-Betrieb als platzsparend erweisen. Eine explizit im Monitor verbaute Kamera schränkt die Auswahl immens ein, daher wähle nur "Ja", wenn sie unverzichtbar ist.',
          options: [
            { id: 1, label: "Ja", nextQuestionId: 3, iconPath: "/wp-content/plugins/monitor-berater/Ja.png", explanation: "Kamera ist inklsuive, nur für deine Ansprüche!" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
            {
              id: 3,
              label: "Wäre gut, aber nicht zwingend.",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 8,
          id: 8,
          question: "Wie würdest du dein Erfahrungslevel in der Bild-/ Videobearbeitung beschreiben? Bitte wähle die am besten zutreffende Option aus:",
          tooltip: "Für Einsteiger oder Personen, die erste Schritte in der Bild- und Videobearbeitung unternehmen möchten, ist die Option 'Anfänger' ideal. 'Hobbymäßig' beschreibt gut diejenigen, die bereits einige Erfahrungen gesammelt haben und regelmäßig bearbeiten, jedoch nicht beruflich tätig sind. Wenn du bereits erweiterte Kenntnisse und Erfahrung hast, ist 'Fortgeschritten' die passende Wahl. 'Professionell' solltest du nur auswählen, wenn du einen Monitor auf annäherndem Expertenniveau benötigst.",
          options: [
            {
              id: 1,
              label: "Anfänger",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Anfaenger.png",
              explanation: "Einsteiger profitieren von Grafik-Monitoren, die eine solide Farbdarstellung bieten und preislich attraktiv sind."
            },
            {
              id: 2,
              label: "Hobbymäßig",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Hobby.png",
              explanation: "Für regelmäßige Hobbybearbeitung sind gute Farbgenauigkeit und Bildqualität empfehlenswert."
            },
            {
              id: 3,
              label: "Fortgeschritten",
              nextQuestionId: 40,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Fortgeschritten.png",
              explanation: "Fortgeschrittene Grafik-Monitore benötigen eine präzise Farbwiedergabe, hohe Auflösung und gute Ergonomie."
            },
            {
              id: 4,
              label: "Proffessionell",
              nextQuestionId: 40,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Professionell.png",
              explanation: "Für professionelle Grafik-Monitore sind exzellente Farbtreue und höchste Auflösung entscheidend."
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 9,
          id: 9,
          question: "Was ist deine bevorzugte Größe beim Monitor?",
          tooltip: 'Mittlerweile sind 27 Zoll der Standard und werden auch bevorzugt hergestellt. Dennoch hängt die Monitorgröße mit von deiner persönlichen Präferenz ab. Ab 32 Zoll gibt es auch extrabreite (UltraWide) Monitore, die beim Office 2 Monitore ersetzen können und in Spielen eine höhere Immersion bieten können.',
          options: [
            {
              id: 1,
              label: "21-24 Zoll (53-64 cm)",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
              explanation: "Kleinere und kompakte 21-24 Zoll Monitore.",
            },
            {
              id: 2,
              label: "27-31,5 Zoll (68-80 cm)",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
              explanation: "Angemessene und gute Größe: 27 - 31,5 Zoll Monitore.",
            },
            {
              id: 3,
              label: "32 Zoll oder mehr (81 cm)",
              nextQuestionId: 11,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
              explanation: "Manchmal ist mehr gleich mehr: Mindestens 32 Zoll Monitore.",
            },
            {
              id: 4,
              label: "Ich möchte selber einen exakten Größenbereich angeben",
              nextQuestionId: 10,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 10,
          id: 10,
          question: "Gib bitte den Größenbereich für deinen neuen Monitor an:",
          tooltip: "Du kannst ein genaues Intervall angeben, in dem sich dein neuer Monitor befinden darf.",
          options: [
            {
              id: 1,
              label: "21-25 Zoll",
              nextQuestionId: 13,
              iconPath: "/wp-content/plugins/monitor-berater/icons8-monitor-50.png",
              lowerValue: 20,
              upperValue: 32,
            },
          ],
          lowerValue: 20,
          upperValue: 32,
          nextQuestionId: 18,
          selectedOptionId: null,
          selectedOptionIds: [],
          isSlider: true,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 18,
          id: 18,
          question: "Wie wichtig ist eine gestochen scharfe Bilddarstellung bei deinem neuen Monitor?",
          tooltip: 'Die Schärfe eines Bildes hängt von der Pixeldichte des Displays ab, die sich aus dem Verhältnis von Auflösung zu Bildschirmgröße ergibt. Für die meisten ist der empfohlene Standard ideal: Er kombiniert eine hohe Bildschärfe im mittleren Preissegement und erfüllt damit die Anforderungen der meisten Nutzer. Wähle "Überdurchschnittliche Schärfe", wenn dir ein besonders scharfes Bild wichtig ist – dies spiegelt sich allerdings im Preis wieder. Falls dir der Preis am wichtigsten ist, wähle einfach "Hauptsache günstig".',
          options: [
            {
              id: 0,
              label: "Hauptsache günstig",
              nextQuestionId: 2,
              explanation: "Preiswerte Bildschärfe für's Office: PPI von 70 bis 99",
            },
            {
              id: 1,
              label: "Empfohlener Standard",
              nextQuestionId: 2,
              explanation: "Gute bis sehr gute Bildschärfe für's Office: PPI von 90 bis 120. Höhere werden allerdings bevorzugt!",
            },
            {
              id: 2,
              label: "Überdurchschnittliche Schärfe",
              nextQuestionId: 2,
              explanation: "Exzellente Bildschärfe für's Office: ab einer PPI von 105 und bevorzugt noch höhere.",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 11,
          id: 11,
          question: "Möchtest du explizit einen extrabreiten Monitor?",
          tooltip: "Ein Ultrawide-Monitor lohnt sich, wenn du viel Multitasking betreibst und oft mehrere Fenster nebeneinander nutzt oder intensiveres Eintauchen in Spiele schätzt.  Dennoch: Extrabreite Monitore gefallen nicht jedem, am Ende ist deine Vorliebe entscheidend.",
          options: [
            { id: 1, label: "Ja", nextQuestionId: 17, iconPath: "/wp-content/plugins/monitor-berater/Ja.png" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
            {
              id: 3,
              label: "Bin mir noch unsicher",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 12,
          id: 12,
          question:
            "Benutzt du ein oder mehrere der folgende Programme? (Mehrfachauswahl möglich)",
          tooltip: "Die Anforderungen an verschiedene Programme können variieren und je nach dem eignen sich bestimmte Monitore besser.",
          options: [
            {
              id: 1,
              label: "Adobe Creative Cloud Suite",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Adobe_Creative_Cloud.png",
              isSelected: false,
            },
            {
              id: 2,
              label: "DaVinci Resolve",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/DaVinci.png",
              isSelected: false,
            },
            {
              id: 3,
              label: "Final Cut Pro",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/final_cut.png",
              isSelected: false,
            },
            {
              id: 4,
              label: "Avid Media Composer",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Media_Composer_Logo.png",
              isSelected: false,
            },
            {
              id: 5,
              label: "CorelDRAW",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/corelDraw.png",
              isSelected: false,
            },
            {
              id: 6,
              label: "Affinity Photo und Designer 2",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/affinity-designer.png",
              isSelected: false,
            },
            {
              id: 7,
              label: "Capture One Pro",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/CAPTURE_ONE_LOGO.png",
              isSelected: false,
            },
            {
              id: 8,
              label: "Sony Vegas Pro",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Vegas_Pro.png",
              isSelected: false,
            },
            // { id: 9, label: "Magix Video Pro X", nextQuestionId: 3, iconPath: "usbc.png", isSelected: false},
            // { id: 4, label: "Keine der genannten", nextQuestionId: 3, iconPath: "dvi.png", isSelected: false},
          ],
          selectedOptionIds: [],
          isSlider: false,
          isStepSlider: false,
          isCheckbox: true,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 13,
          id: 13,
          question:
            "Welche Anschlüsse sind für dich unverzichtbar? (Mehrfachauswahl möglich)",
          tooltip: "Wähle nur die Anschlüsse, die du wirklich brauchst. Besonders verbreitet sind HDMI- und DisplayPort-Anschlüsse, da sie sich für die meisten Bildschirme und Geräte eignen. So stellst du sicher, dass wichtige Verbindungen vorhanden sind. Für Profis können am Ende, durch umdrehen der Produktkarten, die Versionen der Anschlüsse identifizeirt werden.",
          options: [
            {
              id: 1,
              label: "HDMI",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/HDMI.png",
              isSelected: false,
            },
            {
              id: 5,
              label: "Explizit HDMI 2.1",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/HDMI.png",
              isSelected: false,
              explanation: "Mindestens ein HDMI 2.1 Anschluss",
            },
            {
              id: 2,
              label: "DisplayPort",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/DisplayPort.png",
              isSelected: false,
            },
            /*{
              id: 3,
              label: "USB-C",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/USB_C.png",
              isSelected: false,
            }, */
            {
              id: 4,
              label: "DVI",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/DVI.png",
              isSelected: false,
            },
            /*
            {
              id: 5,
              label: "Thunderbolt",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/Thunderbolt.png",
              isSelected: false,
            },*/
            /*{
              id: 6,
              label: "VGA",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/VGA.png",
              isSelected: false,
            },*/
          ],
          selectedOptionIds: [],
          isSlider: false,
          isStepSlider: false,
          isCheckbox: true,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 14,
          id: 14,
          question:
            "Benötigst du zwingend intergrierte Lautsprecher an deinem Monitor?",
          tooltip: '<span style="font-weight: bold;">Fast geschafft, nur noch 2 Fragen!</span> Direkt integrierte Lautsprecher weisen üblicherweise eine weniger zufriedenstellende Qualität auf. Daher empfiehlt es sich auf Peripheriegeräte zurückzugreifen. Möchtest du dennoch integrierte Lautsprecher haben, so wähle "Ja" aus.',
          options: [
            { id: 1, label: "Ja", nextQuestionId: 15, iconPath: "/wp-content/plugins/monitor-berater/Ja.png" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 15,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",

            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 15,
          id: 15,
          question:
            "Hast du vor deinen neuen Monitor an die Wand zu montieren?",
          tooltip: "Falls du planst, den Monitor an der Wand zu montieren, werden deine Empfehlungen passende VESA-Halterungen enthalten.",
          options: [
            { id: 1, label: "Ja", nextQuestionId: 16, iconPath: "/wp-content/plugins/monitor-berater/Ja.png" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 16,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: true,
        },
        {
          currentQuestionIndex: 16,
          id: 16,
          question: "",
          options: [
            { id: 1, label: "Monitor 1" },
            { id: 2, label: "Monitor 2" },
            { id: 3, label: "Monitor 3" },
            { id: 4, label: "Monitor 4" },
          ],
          selectedOptionId: null,
          isSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: true,
          needLoader: false,
        },
        {
          currentQuestionIndex: 17,
          id: 17,
          question: "Sind bestimmte Verbindungen zur Bildübertragung unverzichtbar?",
          tooltip: "In der Regel haben Monitore immer moderne Anschlüsse, die dem Standard entsprechen.",
          options: [
            { id: 1, label: "Ja", nextQuestionId: 13, iconPath: "/wp-content/plugins/monitor-berater/Ja.png" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 14,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 19,
          id: 19,
          question: "Machst du hauptsächlich Bildbearbeitung, Videoschnitt oder beides ausgeglichen?",
          tooltip: "Ein Monitor zur Bildbearbeitung benötigt andere Leistungsmerkmale als ein Monitor zum Videoschnitt. Im gewissen Maße überschneiden sich diese, allerdings lassen sich kleine Unterschiede kenntlich machen.",
          options: [
            { id: 1, label: "Bildbearbeitung", nextQuestionId: 3, iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung.png" },
            {
              id: 2,
              label: "Videoschnitt",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Videobearbeitung.png",
            },
            {
              id: 3,
              label: "Beides",
              nextQuestionId: 3,
              iconPath: "/wp-content/plugins/monitor-berater/Beides.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 20,
          id: 20,
          question: "Wie wichtig ist eine gestochen scharfe Bilddarstellung beim Arbeiten deines neuen Monitors?",
          tooltip: 'Wähle "Überdurchschnittliche Schärfe", wenn dir ein besonders scharfes Bild wichtig ist – dies spiegelt sich allerdings im Preis wieder. Für die meisten ist der empfohlene Standard ideal: Er bietet gute Schärfe und liegt im mittleren Preissegment. Falls dir der Preis am wichtigsten ist, wähle einfach "Hauptsache günstig".',
          options: [
            {
              id: 0,
              label: "Hauptsache günstig",
              nextQuestionId: 9,
              explanation: "Preiswerte Bildschärfe für Office & Gaming: PPI von 70 bis 99.",
            },
            {
              id: 1,
              label: "Empfohlener Standard",
              nextQuestionId: 9,
              explanation: "Gute Bildschärfe für's Office & Gaming: PPI von 90 bis 120.",
            },
            {
              id: 2,
              label: "Überdurchschnittliche Schärfe",
              nextQuestionId: 9,
              explanation: "Exzellente Bildschärfe für's Office & Gaming: PPI von mindestens 108.",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 21,
          id: 21,
          question: "In welchem Anwendungsbereich befindest du dich?",
          tooltip: 'Büroarbeit beinhaltet allgemeine Aufgaben wie die Nutzung von Word, Excel oder ähnlicher Software und ist in den anderen Auswahlmöglichkeiten bereits enthalten. Das bedeutet: Wenn du hauptsächlich Büroanwendungen nutzt, aber beispielsweise ab und zu programmierst, wähle "Programmieren/ Softwareentwicklung" als deinen Anwendungsbereich.',
          options: [
            {
              id: 1,
              label: "Büroarbeit und Textverarbeitung",
              nextQuestionId: 27,
              iconPath: "/wp-content/plugins/monitor-berater/Textverarbeitung.png",
              explanation: "Für deine Büroanwendungen empfiehlt sich ein Monitor mit augenschonender Darstellung und guter Ergonomie.",
            },
            {
              id: 2,
              label: "Programmieren/ Softwareentwicklung",
              nextQuestionId: 24,
              iconPath: "/wp-content/plugins/monitor-berater/Programmieren.png",
              explanation: "Beim Programmieren sind scharfe Darstellung und gute Ergonomie wichtig, oft auch ein größeres Display oder Multi-Setup.",
            },
            {
              id: 3,
              label: "Grafikdesign/ Bild- und Videobearbeitung",
              nextQuestionId: 22,
              iconPath: "/wp-content/plugins/monitor-berater/GrafikundVideo.png",
              explanation: "Bild- und Videobearbeitung erfordern Monitore mit guter Farbwiedergabe und hoher Auflösung.",
            },
            {
              id: 4,
              label: "CAD-Design und 3D-Modellierung",
              nextQuestionId: 24,
              iconPath: "/wp-content/plugins/monitor-berater/CADund3D.png",
              explanation: "CAD und 3D profitieren besonders von hoher Auflösung und präziser Darstellung feiner Details.",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 22,
          id: 22,
          question: "Wie würdest du dein Erfahrungslevel in der Bild-/ Videobearbeitung beschreiben? Bitte wähle die am besten zutreffende Option aus:",
          tooltip: "Für Einsteiger oder Nutzer, die erste Schritte in der Bild- und Videobearbeitung unternehmen möchten, ist die Option 'Anfänger' ideal. 'Hobbymäßig' beschreibt gut diejenigen, die bereits einige Erfahrungen gesammelt haben und regelmäßig bearbeiten, jedoch nicht beruflich tätig sind. Wenn du bereits erweiterte Kenntnisse und Erfahrung hast, ist 'Fortgeschritten' die passende Wahl. Professionelle Grafiker werden bei Hybrid-Monitoren nicht berücksichtigt. Wenn du zu diesen gehörst, wähle bei der ersten Frage die erste Option aus.",
          options: [
            {
              id: 1,
              label: "Anfänger",
              nextQuestionId: 23,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Anfaenger.png",
            },
            {
              id: 2,
              label: "Hobbymäßig",
              nextQuestionId: 23,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Hobby.png",
            },
            {
              id: 3,
              label: "Fortgeschritten",
              nextQuestionId: 50,
              iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung_Fortgeschritten.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 23,
          id: 23,
          question: "Machst du hauptsächlich Bildbearbeitung, Videoschnitt oder beides ausgeglichen?",
          tooltip: "Ein Monitor zur Bildbearbeitung benötigt andere Leistungsmerkmale als ein Monitor zum Videoschnitt. Im gewissen Maße überschneiden sich diese, allerdings lassen sich kleine Unterschiede kenntlich machen.",
          options: [
            { id: 1, label: "Bildbearbeitung", nextQuestionId: 24, iconPath: "/wp-content/plugins/monitor-berater/Bildbearbeitung.png" },
            {
              id: 2,
              label: "Videoschnitt",
              nextQuestionId: 24,
              iconPath: "/wp-content/plugins/monitor-berater/Videobearbeitung.png",
            },
            {
              id: 3,
              label: "Beides",
              nextQuestionId: 24,
              iconPath: "/wp-content/plugins/monitor-berater/Beides.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 24,
          id: 24,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Monitors hängt davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und PvP-Gaming",
              nextQuestionId: 25,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_PvP.png",
              explanation: "Wettbewerbsorientiertes Gaming erfordert Monitore mit maximaler Reaktionsgeschwindigkeit und hoher Bildrate.",
            },
            {
              id: 2,
              label:
                "Bevorzugt wettbewerbsorientiertes Gaming mit der Option auf angemessene Immersion",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_KompetitivUeberImmersion.png",
              explanation: "Eine gute Balance aus schnellen Reaktionszeiten und hochwertiger Bildqualität sorgt für Flexibilität in Spielen.",
            },
            {
              id: 3,
              label: "Bevorzugt Immersion mit gelegentlichem wettbewerbsorientierten Gaming",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_ImmersionUeberKompetitiv.png",
              explanation: "Für intensive Immersion ist ein Monitor mit guter Farbdarstellung und angemessener Reaktionszeit optimal",
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 30,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_Immersion.png",
              explanation: "Für ein intensives Spielerlebnis sind hohe Auflösung, exzellente Farben und starke Kontraste ausschlaggebend.",
            },
            /*{
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 25,
          id: 25,
          question: "Möchtest du explizit einen Monitor auf eSports-Niveau?",
          tooltip: 'Ein Monitor auf eSports-Niveau muss Leistungsmerkmale bieten, die im wettbewerbsorientierten Gaming entscheidend sind: Eine extrem niedrige Reaktionszeit und hohe Bildwiederholfrequenz sorgen dafür, dass Frames ohne Verzögerung angezeigt werden. Wähle bitte nur "Ja", wenn du dahingehend keine Abstriche machenn möchtest.',
          options: [
            { id: 1, label: "Ja", nextQuestionId: 26, iconPath: "/wp-content/plugins/monitor-berater/gegenNeu.png" },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 26,
              iconPath: "/wp-content/plugins/monitor-berater/Nein.png",
            },
            {
              id: 3,
              label: "Kann, aber muss nicht.",
              nextQuestionId: 26,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 26,
          id: 26,
          question: "Ist dir bekannt von welchem Hersteller deine Grafikkarte ist?",
          tooltip: "Der Hersteller der Grafikkarte ist nicht unbedeutend, da dadurch zusätzliche Funktionen des Monitors berücksichtigt werden können.",
          options: [
            {
              id: 1,
              label: "NVIDIA",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/nvidia_logo.png",
            },
            {
              id: 2,
              label: "AMD",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/amd_logo.png",
            },
            {
              id: 3,
              label: "Intel",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/intel_logo.png",
            },
            {
              id: 4,
              label: "Unsicher",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 27,
          id: 27,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Monitors hängt davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und PvP-Gaming",
              nextQuestionId: 28,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_PvP.png",
            },
            {
              id: 2,
              label:
                "Bevorzugt wettbewerbsorientiertes Gaming mit der Option auf angemessene Immersion",
              nextQuestionId: 28,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_KompetitivUeberImmersion.png",
            },
            {
              id: 3,
              label: "Bevorzugt Immersion mit gelegentlichem wettbewerbsorientierten Gaming",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_ImmersionUeberKompetitiv.png",
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 30,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_Immersion.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 28,
          id: 28,
          question: "Ist dir bekannt von welchem Hersteller deine Grafikkarte ist?",
          tooltip: "Der Hersteller der Grafikkarte ist nicht unbedeutend, da dadurch zusätzliche Funktionen des Monitors berücksichtigt werden können.",
          options: [
            {
              id: 1,
              label: "NVIDIA",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/nvidia_logo.png",
            },
            {
              id: 2,
              label: "AMD",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/amd_logo.png",
            },
            {
              id: 3,
              label: "Intel",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/intel_logo.png",
            },
            {
              id: 4,
              label: "Unsicher",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        // For the different path for full immersion and advanced grphicers because of size
        {
          currentQuestionIndex: 30,
          id: 30,
          question: "Ist dir bekannt von welchem Hersteller deine Grafikkarte ist?",
          tooltip: "Der Hersteller der Grafikkarte ist nicht unbedeutend, da dadurch zusätzliche Funktionen des Monitors berücksichtigt werden können.",
          options: [
            {
              id: 1,
              label: "NVIDIA",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/nvidia_logo.png",
            },
            {
              id: 2,
              label: "AMD",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/amd_logo.png",
            },
            {
              id: 3,
              label: "Intel",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/intel_logo.png",
            },
            {
              id: 4,
              label: "Unsicher",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 31,
          id: 31,
          question: "Was ist deine bevorzugte Größe beim Monitor?",
          tooltip: 'Monitore für eine gute Immersion durch Schärfe, Farbdarstellung und gleichzeitig optimalem Bildaufbau können Monitore ab dem bereich von 27 Zoll gewährleistet werden. Darüberhinaus hängt die Monitorgröße mit von deiner persönlichen Präferenz ab. Ab 32 Zoll gibt es auch extrabreite (UltraWide) Monitore, die nochmal eine verbesserte Immersion in Grafikspielen bieten können, aber natürlich auch den Preis steigen lässt.',
          options: [
            {
              id: 2,
              label: "27-31,5 Zoll (68-80 cm)",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
            {
              id: 3,
              label: "32 Zoll oder mehr (81 cm)",
              nextQuestionId: 11,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
            {
              id: 4,
              label: "Ich möchte selber einen exakten Größenbereich angeben",
              nextQuestionId: 10,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        // End of different path for immersion and graphicers because of size

        // Start different Path for Graphics professional cause different path

        {
          currentQuestionIndex: 40,
          id: 40,
          tooltip: "Überlege, ob der Grafik-Monitor in der Nähe von Fenstern steht, durch die direktes Sonnenlicht auf den Bildschirm fällt. Solche Lichtquellen können das Ablesen am Display beeinträchtigen, dem durch technische Spezifikationen entgegen gewirkt werden kann. Bei rein künstlicher Beleuchtung, wie Lampen, können diese sanfter berücksichtigt werden.",
          question: "Wie sind die Lichtverhältnisse an dem Platz, wo dein neuer Grafik-Monitor stehen wird?",
          options: [
            {
              id: 1,
              label:
                "Direkte Sonneneinstrahlung auf das Display ist durchgehend vorhanden.",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/Sonnenlicht.png",
            },
            {
              id: 2,
              label:
                "Überwiegend künstliches Licht bzw. nutze meist Jalousinen oder ähnliches.",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/KünstlichesLicht.png",
            },
            {
              id: 3,
              label: "Der Monitor steht überwiegend in dunkler Umgebung.",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/Dunkel.png",
            },
            {
              id: 4,
              label: "Kann ich nicht genau sagen.",
              nextQuestionId: 31,
              iconPath: "/wp-content/plugins/monitor-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 41,
          id: 41,
          question: "Was ist deine bevorzugte Größe beim Monitor?",
          tooltip: 'Für mindestens fortgeschrittene Grafik-Designer sollten mindestens Monitore im Bereich der 27 Zoll genutzt werden. Durch erhöhte Schärfe, Farbdarstellung und Farbgenauigkeit wird sichergestellt, dass Details im Vordergrund der Anwendung liegen. Darüberhinaus hängt die Monitorgröße mit von deiner persönlichen Präferenz ab. Ab 32 Zoll gibt es auch extrabreite (UltraWide) Monitore, die durch ihre große Fläche an Produktivität in Programmen gewinnen können, aber gerade für die Verwendung der Preis stark ansteigt.',
          options: [
            {
              id: 2,
              label: "27-31,5 Zoll (68-80 cm)",
              nextQuestionId: 17,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
            {
              id: 3,
              label: "32 Zoll oder mehr (81 cm)",
              nextQuestionId: 11,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
            {
              id: 4,
              label: "Ich möchte selber einen exakten Größenbereich angeben",
              nextQuestionId: 10,
              iconPath: "/wp-content/plugins/monitor-berater/Zoll.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        // Different Filtering for Imemrsion and Graphicers - and new path gen
        {
          currentQuestionIndex: 50,
          id: 50,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Monitors hängt davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und PvP-Gaming",
              nextQuestionId: 25,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_PvP.png",
            },
            {
              id: 2,
              label:
                "Bevorzugt wettbewerbsorientiertes Gaming mit der Option auf angemessene Immersion",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_KompetitivUeberImmersion.png",
            },
            {
              id: 3,
              label: "Bevorzugt Immersion mit gelegentlichem wettbewerbsorientierten Gaming",
              nextQuestionId: 20,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_ImmersionUeberKompetitiv.png",
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 30,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_Immersion.png",
            },
            /*{
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 60,
          id: 60,
          question: "Welche Konsole soll der Monitor bedienen?",
          tooltip: "Es ist wichtig zu wissen, welche Konsole du nutzt, da sie verschiedene technische Spezifikationen haben und dementsprechend das Potenzial eines Monitors überhaupt nutzen können.",
          options: [
            {
              id: 1,
              label:
                "Playstation 5",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/ps5.png",
              explanation: "Passend zur Leistung der PS5 Konsole.",
            },
            {
              id: 2,
              label:
                "Playstation 5 Pro",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/ps5pro.png",
              explanation: "Passend zur Leistung der PS5 Pro Konsole.",
            },
            {
              id: 3,
              label: "Xbox Series S",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/xboxseriess.png",
              explanation: "Passend zur Leistung der Xbox Series S Konsole.",
            },
            {
              id: 4,
              label:
                "Xbox Series X",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/xboxseriesx.png",
              explanation: "Passend zur Leistung der Xbox Series X Konsole.",
            },

            {
              id: 5,
              label:
                "Playstation 4",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/ps4.png",
              explanation: "Passend zur Leistung der PS4 Konsole.",
            },

            {
              id: 6,
              label:
                "Xbox One",
              nextQuestionId: 61,
              iconPath: "/wp-content/plugins/monitor-berater/xboxone.png",
              explanation: "Passend zur Leistung der Xbox One Konsole.",
            },
            /*{
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 61,
          id: 61,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Konsolen-Monitors hängt stark davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und PvP-Gaming",
              nextQuestionId: 41,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_PvP.png",
            },
            {
              id: 2,
              label:
                "Bevorzugt wettbewerbsorientiertes Gaming mit der Option auf angemessene Immersion",
              nextQuestionId: 41,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_KompetitivUeberImmersion.png",
            },
            {
              id: 3,
              label: "Bevorzugt Immersion mit gelegentlichem wettbewerbsorientierten Gaming",
              nextQuestionId: 41,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_ImmersionUeberKompetitiv.png",
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 41,
              iconPath: "/wp-content/plugins/monitor-berater/Gaming_Immersion.png",
            },
            /*
            {
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },






      ],
    };
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-image: url("");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-back {
  transform: rotateY(180deg);
  position: absolute;
}

.label-data-front {
  color: #999
}


#form .typewriter-container {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  width: 40%;
  text-align: justify;
}

.question-text {
  font-size: 18px;
  margin-top: 10px;
}



h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
}

#form .container-infobox {
  text-align: left;

}

.typewriter>* {
  color: transparent;
  position: relative;
}

.icon-margin-right {
  margin-right: 8px;
}

.typewriter>*::after {
  content: attr(data-content);
  color: var(--font-color, black);
  position: absolute;
  left: 0;
  top: 0;
}

#form blockquote.speech-bubble {
  --arrow-w: 0.5em;
  --arrow-h: 1em;
  --bubble-corners: 5px;
  --w: 12em;
  --border-size: 1.5px;
  --text-color: black;
  --bubble-color: white;
  --border-color: #c2ab92;
}

#form blockquote.speech-bubble {
  --arrow-w: 0.5em;
  --arrow-h: 1em;
  --bubble-corners: 5px;
  --w: 12em;
  --border-size: 1.5px;
  --text-color: black;
  --bubble-color: white;
  --border-color: #daab4f;
}

#form blockquote.speech-bubble {
  text-align: center;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 15px;
  font-weight: None;
  color: var(--text-color);
  background: var(--bubble-color);
  padding: 1.5rem 2.5rem;
  border-radius: var(--bubble-corners);
  box-shadow: 0 0 0 var(--border-size) var(--border-color);
  line-height: none;
  border: None;
}

#form blockquote.speech-bubble.round {
  --bubble-corners: 1em;
}

#form blockquote.speech-bubble.circle {
  --bubble-corners: 100%;
  padding: 2em;
}





#form blockquote.speech-bubble.pop {
  animation-name: pop;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
}

@keyframes pop {
  0% {
    transform: scale(0.8);
  }

  80% {
    transform: scale(1.1);
  }

  90% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes float-up {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-left {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-right {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(var(--arrow-h));
  }
}

@keyframes float-down {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(var(--arrow-h));
  }
}

#form .container.topCont {
  padding-top: 0px;
  background: linear-gradient(193deg, #9471427d, #ddcfbd69 50%, #978b801a);
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

}

@media (min-width: 1500px) {
  .container.topCont {
    max-width: 1230px;
    padding-top: 0px;
  }
}

#form .dingoPic {
  max-height: 250px;
  width: 20%;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: -40px;
  margin-right: 5px;
}

@media (max-width: 576px) {
  #form .dingoPic {
    max-height: 350px;
    width: 20%;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 5px;
    margin-bottom: 0;
  }

}

.question-title {
  font-family: HKGroteskPro, serif !important;
}

#form .btn12 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

#form .btn12-next {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

#form .btn13-back {
  background-color: #0d6efd30;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

.back-button-wrapper {
  margin-top: 10px;
  margin-left: 15px;
  margin-bottom: 20px;
}

@media (min-width: 1024px) {
  .firstPage-info {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
  }
}

@media (min-width: 1024px) {
  .underQuestion {}
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

/* Ausgehende Elemente - Absolut positioniert und ausgeblendet */
.slide-fade-leave-from {
  opacity: 1;
  transform: translateX(0);

  width: 100%;
  /* Passt die Breite an, um das Layout zu erhalten */
}

.slide-fade-leave-to {
  opacity: 0;
  display: block;
  transform: translateX(0);
}

.slide-fade-leave-active {
  transition: opacity 0.5s ease;
}

.infoText {
  text-align: left;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  text-align: center;
  color: white;
}

.rotating-image {
  width: 100px;
  animation: spin 2s linear infinite;
}

.loading-text {
  font-size: 1.5rem;
  margin-top: 1rem;
  animation: fadeInOutFast 2.5s ease-in-out infinite;
}


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeInOutFast {

  0%,
  15% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }

  85%,
  100% {
    opacity: 0;
  }
}

.line-gap {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: .25;
  height: 1px;
  background-color: #ccc;
  width: 100%;
}

h2.question-title {
  font-weight: 500 !important;
  font-size: 37px !important;
  font-family: HKGroteskPro, serif !important;
}


@media (max-width: 768px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}


@media (max-width: 480px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}

.sort-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sort-container label {
  margin-bottom: 0.2em;
  font-weight: bold;
}

.sort-container select {
  padding: 0.25em 0.5em;
}

.spanField {
  background-color: #b9d1ff;
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
}

@media (min-width: 576px) {
  .form-select {
    width: auto;
  }
}

h1.firstPage {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 0.5rem;
}

.card2 {
  width: 60%;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 40em;
  margin: 0 auto 1rem;
}

.logoMw {
  display: block;
}

@media (max-width: 768px) {
  .logoMw {
    display: none;
  }
}

.intro-text {
  text-align: left;
  max-width: 40em;

  margin: 0 auto 1.5rem;
  line-height: 1.6;
}


.detail-desc {
  text-align: left;
  padding: 0.5rem 1rem;
}

.image-container {
  text-align: center;
  margin: 1.5rem 0;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .card2 {
    width: 100%;
    padding: 0 1rem;
  }

  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logoMw {
    margin-top: 1rem;
    align-self: flex-start;
  }

  .intro-text {
    max-width: 100%;
  }
}


@media (min-width: 768px) and (max-width: 1023px) {

  .container-md.underQuestion {
    max-width: 720px;
    padding: 1rem;
  }


  .row.g-0>.col-12 {}

  .card2 {
    width: 80%;
    margin: 1rem auto;
  }

  .firstPage-info {
    width: 80%;
    margin: 1.5rem auto;
  }

  h2.question-title {
    font-size: 32px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {

  .col-md-6 {
    flex: 0 0 auto;
    width: 80%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .multisteps_form {}
}

@media (min-width: 768px) and (max-width: 1024px) {
  .multisteps_form {}
}

/*Progress Bar Custom */
.row>.progress-glass {
  padding-left: 0;
  padding-right: 0;
}

.progress-glass {
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  --fill-start: rgb(255 255 255 / 0%);
  --fill-end: rgb(232 243 238 / 1)
}

.progress-glass__fill {
  display: block;
  height: 100%;
  background: linear-gradient(90deg,
      var(--fill-start) 0%,
      var(--fill-end) 100%);
  border-radius: inherit;
  transition: width 0.4s ease;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>